import { render, staticRenderFns } from "./AmetrasFormularWrapper.vue?vue&type=template&id=ced021b6&scoped=true&"
import script from "./AmetrasFormularWrapper.vue?vue&type=script&lang=ts&"
export * from "./AmetrasFormularWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced021b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
